webpackJsonp([222968204142371],{

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DSPage = function (_React$Component) {
	  _inherits(DSPage, _React$Component);
	
	  function DSPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DSPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { azMode: true }, _this.toggleMode = function () {
	      return _this.setState({ azMode: !_this.state.azMode });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DSPage.prototype.render = function render() {
	    var data = this.props.data;
	    var azMode = this.state.azMode;
	
	    var DSQuery = azMode ? data.DSQueryAZ : data.DSQueryChron;
	    return _react2.default.createElement(
	      'article',
	      { className: 'post post-ds' },
	      _react2.default.createElement(
	        'header',
	        { className: 'post-header clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'post-head-wrap' },
	          ' ',
	          _react2.default.createElement(
	            'div',
	            { className: 'post-head-content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'post-title' },
	              'Design Systems Gallery'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A comprehensive and curated list of design systems, style guides and pattern libraries that you can use for inspiration.'
	            )
	          ),
	          ' ',
	          _react2.default.createElement('img', {
	            className: 'illustration',
	            src: 'https://d33wubrfki0l68.cloudfront.net/c212c67984cc23c7dc3ebb51b9798db3af6c435f/f3cdb/images/illustration-ds.svg',
	            width: '94',
	            height: '86',
	            alt: 'Design System Legos'
	          })
	        ),
	        ' '
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'filter' },
	        ' ',
	        _react2.default.createElement(
	          'li',
	          { className: azMode && 'active' },
	          _react2.default.createElement(
	            'a',
	            { onClick: this.toggleMode },
	            'A - Z ',
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              '(',
	              DSQuery.edges.length,
	              ')'
	            )
	          )
	        ),
	        ' ',
	        _react2.default.createElement(
	          'li',
	          { className: !azMode && 'active' },
	          _react2.default.createElement(
	            'a',
	            { onClick: this.toggleMode },
	            'Most recent'
	          )
	        ),
	        ' '
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'post-content holder' },
	        DSQuery.edges.map(function (_ref) {
	          var _ref$node = _ref.node,
	              fields = _ref$node.fields,
	              frontmatter = _ref$node.frontmatter;
	          return _react2.default.createElement(
	            'a',
	            {
	              key: frontmatter.link,
	              className: 'block block-ds',
	              href: frontmatter.link,
	              title: frontmatter.title,
	              target: '_blank'
	            },
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'img-wrap' },
	              _react2.default.createElement('img', {
	                src: '/' + frontmatter.image,
	                alt: frontmatter.title,
	                width: '800',
	                height: '400'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              ' ',
	              _react2.default.createElement(
	                'h3',
	                null,
	                frontmatter.company
	              ),
	              ' ',
	              _react2.default.createElement(
	                'h2',
	                null,
	                frontmatter.title
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'clamp' },
	                frontmatter.description
	              ),
	              ' '
	            ),
	            ' '
	          );
	        })
	      )
	    );
	  };
	
	  return DSPage;
	}(_react2.default.Component);
	
	exports.default = DSPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-design-systems-js-78b1949741f63cd8bf29.js